module.exports = __webpack_public_path__ + "static/media/upload-title@2x.3f2c87ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/upload-title@2x.png
// module id = 923
// module chunks = 0